<template>
    <Rating v-model="text" :stars="max" :cancel="cancel" :disabled="disabled" :readonly="readonly" style="display: inline-block;" />
</template>

<script>
import { computed } from 'vue'
import Rating from 'primevue/rating';

export default {
    name: 'tw-rate',
    components: {
        Rating
    },
    setup(props, context) {
        const text = computed({
            get() {
                return (props.modelValue === null || props.modelValue === undefined) ? 0 : props.modelValue
            },
            set(value){
                context.emit('update:modelValue', value)
            }
        })

        return {
            text
        }
    },
    props: {
        modelValue: Number,
        max: Number,
        disabled: Boolean,
        readonly: Boolean,
        cancel: Boolean
    }
}
</script>
